'use strict';

var PostBookingBagsCollection = Odigeo.Collection.extend({
    model: Odigeo.Model.extend({
        defaults: {
            pieces: 0,
            kilos: 0,
            amount: 0,
            currencyCode: null,
            currencyConfig: null,
            travelerIndex: -1,
            segmentIndex: -1,
            bagIndex: -1,
        },
    }),

    getBag: function(searchPattern) {
        return this.findWhere(Odigeo._.isUndefined(searchPattern) ? {} : searchPattern);
    },

    getBags: function(searchPattern) {
        return this.where(Odigeo._.isUndefined(searchPattern) ? {} : searchPattern);
    },

    getTotalPrice: function() {
        return this.reduce(function(sum, bag) {
            return sum + bag.get('amount');
        }, 0);
    },

    getCurrencyCode: function() {
        return this.hasSelectedAnyBags() ? this.first().get('currencyCode') : null;
    },

    getCurrencyConfig: function() {
        return this.hasSelectedAnyBags() ? this.first().get('currencyConfig') : null;
    },

    getTotalPieces: function() {
        return this.reduce(function(sum, bag) {
            return sum + bag.get('pieces');
        }, 0);
    },

    getAverageFee() {
        return this.reduce((sum, bag) => sum + bag.get('baggageFee').amount, 0) / this.length;
    },

    getPriceBreakdown: function() {
        return Odigeo._.chain(this.toJSON())
            .groupBy(function(el) {
                return [el.pieces, el.kilos, el.amount].join('-');
            })
            .map(function(el) {
                var quantity = el.length;
                var price = el[0].amount - el[0].baggageFee.amount;
                var fee = el[0].baggageFee.amount;
                var amount = el[0].amount;
                return {
                    type: 'BAG',
                    quantity: quantity,
                    pieces: el[0].pieces,
                    kilos: el[0].kilos,
                    price: price,
                    fee: fee,
                    amount: amount,
                    totalPrice: quantity * price,
                    totalFee: quantity * fee,
                    totalAmount: quantity * amount,
                    currencyCode: el[0].baggageFee.currencyCode,
                };
            })
            .value();
    },


    hasSelectedAnyBags: function() {
        return this.length > 0;
    },

    hasSelectedBagForSegment: function(travelerIndex, segmentIndex) {
        return !!this.getBag({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
        });
    },

    getSelectedBagForSegment: function(travelerIndex, segmentIndex) {
        var result = this.getBag({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
        });

        return result ? result.toJSON() : result;
    },

    hasBag: function(travelerIndex, segmentIndex, bagIndex) {
        return !!this.getBag({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
            bagIndex: bagIndex,
        });
    },

    addBag: function(travelerIndex, segmentIndex, bagIndex, selectableBag) {
        this.add({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
            bagIndex: bagIndex,
            pieces: selectableBag.pieces,
            kilos: selectableBag.kilos,
            amount: selectableBag.amount,
            currencyCode: selectableBag.currencyCode,
            currencyConfig: selectableBag.currencyConfig,
            baggageFee: selectableBag.baggageFee,
        });
    },

    removeBag: function(travelerIndex, segmentIndex) {
        this.remove(this.getBag({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
        }));
    },
});

var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new PostBookingBagsCollection();
    }
    return instance;
};
